import React from 'react';
import { motion } from 'framer-motion';
import Tilt from 'react-parallax-tilt';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import { projects } from '../constants/projects';
import './Projects.css';

const Projects = () => {
  return (
    <section id="projects" className="section projects">
      <div className="container">
        <motion.div className="section-header" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="section-title text-gradient">Selected Work</h2>
          <div className="title-underline"></div>
        </motion.div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <motion.div 
              key={project.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
            >
              <Tilt 
                tiltMaxAngleX={5} 
                tiltMaxAngleY={5} 
                perspective={1000} 
                transitionSpeed={1000} 
                scale={1.02}
                gyroscope={true}
                className={`project-card glass-panel hover-target ${project.featured ? 'featured' : ''}`}
              >
                <div className="project-image-container">
                  {project.image ? (
                    <img src={project.image} alt={project.title} className="project-image" />
                  ) : (
                    <div className="project-image-fallback">
                      <div className="fallback-gradient"></div>
                      <span>{project.title.charAt(0)}</span>
                    </div>
                  )}
                  <div className="project-overlay">
                    <div className="project-actions">
                      {project.githubLink && <a href={project.githubLink} target="_blank" rel="noreferrer" className="btn-icon" aria-label={`View ${project.title} source code on GitHub`}><FaGithub aria-hidden="true" /></a>}
                      {project.liveLink && <a href={project.liveLink} target="_blank" rel="noreferrer" className="btn-icon" aria-label={`View ${project.title} live deployment`}><FaExternalLinkAlt aria-hidden="true" /></a>}
                    </div>
                  </div>
                </div>

                <div className="project-content">
                  <span className="project-role">{project.role}</span>
                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-description">{project.description}</p>
                  
                  <div className="project-tech">
                    {project.techStack.map(tech => <span key={tech} className="tech-tag">{tech}</span>)}
                  </div>
                </div>
              </Tilt>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
